import * as React from "react";
import {isEmpty as _isEmpty} from "lodash";
import ChatContainer from "./ChatContainer";
import {
  PATIENT_CONSULTATIONS,
  PATIENT_ID_PARAM,
  ROUTE_PARAMS_SEPARATOR,
  RouteUtils
} from "../../routes";
import AppUtils from "../../utils/AppUtils";
export interface ChatContainerWrapperProps {
  patientId?: number;
  hideOnLoad?: boolean;
  communicationAccessToken: string;
  userIdentity: string;
  chatChannelName?: string;
  chatChannelSid?: string;
  userName: string;
  stackToRight?: boolean;
  clearCurrentChannel?: () => void;
  currentChannel: any;
  clientsLoading: boolean;
}
export interface ChatContainerWrapperState {
  isExpanded: boolean;
  hasReceivedNewMessage: boolean;
  showFileUploadScreen: boolean
}
class ChatContainerWrapper extends React.Component<
  ChatContainerWrapperProps,
  ChatContainerWrapperState
  > {
  constructor(props: ChatContainerWrapperProps) {
    super(props);
    let isExpanded =
      this.props.hideOnLoad !== undefined ? !this.props.hideOnLoad : true;
    isExpanded = isExpanded && !window.location.href.includes("ongoing");
    this.state = {
        isExpanded,
        hasReceivedNewMessage: false,
        showFileUploadScreen: false
    };
  }
  componentWillReceiveProps(nextProps: ChatContainerWrapperProps) {
    if (nextProps.chatChannelSid !== this.props.chatChannelSid) {
      this.setState({
        isExpanded: true
      });
    }
  }
  toggleChat = (flag?: boolean) => {
    let currStatus = this.state.isExpanded;
    this.setState({
      isExpanded: !_isEmpty(flag) ? flag : !currStatus,
      hasReceivedNewMessage: false
    });
  };
  clearCurrentChannel = () => {
    if (
      window.location &&
      window.location.pathname &&
      window.location.pathname.includes("/ongoing")
    ) {
      this.toggleChat();
    } else {
      if (this.props.clearCurrentChannel !== undefined)
        this.props.clearCurrentChannel();
    }
  };
  toogleUnreadDotOnMobileChatHead = () => {
    this.setState({ hasReceivedNewMessage: true });
  }

  toggleFileUploadScreen = () => {
      this.setState((prevState) => ({showFileUploadScreen: !prevState.showFileUploadScreen}))
  }

  handleBackClick = (event: any) => {
      event.stopPropagation()
      this.toggleFileUploadScreen()
  }

  renderChatContainerHeader = (isMobile: boolean) => {
      const {showFileUploadScreen} = this.state

      // desktop
      if (!isMobile) {
          if (!showFileUploadScreen) {
              return (
                  <div className={"chat-container-handle"} onClick={() => this.toggleChat()}>
                      <span className={`patient-name`}>{this.props.userName}</span>
                      <span className={`glyphicon glyphicon-remove`} onClick={this.clearCurrentChannel} />
                  </div>
              )
          } else {
              return (
                  <div className={"chat-container-handle"} onClick={() => this.toggleChat()}>
                      <span className={`chat-header-text`}>{"Upload 1 file"}</span>
                      <span className={`glyphicon glyphicon-chevron-left`} onClick={this.handleBackClick} />
                  </div>
              )
          }
      } else {
          // mobile
          if (!showFileUploadScreen) {
              return (
                  <div className={"chat-container-handle"} onClick={() => this.toggleChat()} >
                      <img src="/images/date-left-nav.png" onClick={this.clearCurrentChannel} alt="close-chat" />
                      <div className="display-image">{this.props.userName[0].toUpperCase()}</div>
                      <div className={`patient-name`}>{this.props.userName}</div>
                  </div>
              )
          } else {
              return (
                  <div className={"chat-container-handle"} onClick={() => this.toggleChat()}>
                      <span className={`chat-header-text`}>{"Upload 1 file"}</span>
                      <span className={`glyphicon glyphicon-chevron-left`} onClick={this.handleBackClick} />
                  </div>
              )
          }
      }
  }

  render() {
    let myInstance = this;
    let cssClass = this.state.isExpanded ? "" : "collapsed";
    let wrapperClass = "";
    if (this.props.stackToRight !== undefined && this.props.stackToRight) {
      wrapperClass = "stack-to-right";
    }
    // let patientId = this.props.patientId;
    // let patientProfileUrl = PATIENT_CONSULTATIONS.replace(
    //   ROUTE_PARAMS_SEPARATOR,
    //   ""
    // ).replace(PATIENT_ID_PARAM, patientId.toString());
    let isMobile = AppUtils.getIsMobile();
    let isOngoing = location.pathname.includes("ongoing");
    // let glyphClass = this.state.isExpanded ? "glyphicon-minus" : "glyphicon-plus";
    const hiddenMobile = isMobile && isOngoing && !this.state.isExpanded;
    return (
      <React.Fragment>
        {isMobile && !this.state.isExpanded && (
          <div className="chat-head-mobile" onClick={() => this.toggleChat()}>
            <img src="/images/chat-icon.svg" alt="chat-head" />
            {this.state.hasReceivedNewMessage &&
              <div className="unread-dot"></div>
            }
          </div>
        )}
        <div className={`chat-container-wrapper ${wrapperClass} ${(isMobile && isOngoing) ? "ongoing-chat" : ""}`}
          style={hiddenMobile ? { display: "none" } : {}}>
            {this.renderChatContainerHeader(isMobile)}
          <div className={`chat-container-content ${cssClass}`}>
            <ChatContainer
              isExpanded={this.state.isExpanded}
              userIdentity={myInstance.props.userIdentity}
              chatChannelName={myInstance.props.chatChannelName}
              chatChannelSid={myInstance.props.chatChannelSid}
              communicationAccessToken={myInstance.props.communicationAccessToken}
              currentChannel={myInstance.props.currentChannel}
              clientsLoading={myInstance.props.clientsLoading}
              patientName={myInstance.props.userName}
              toogleUnreadDotOnMobileChatHead={this.toogleUnreadDotOnMobileChatHead}
              toggleFileUploadScreen={this.toggleFileUploadScreen}
              showFileUploadScreen={this.state.showFileUploadScreen}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default ChatContainerWrapper;